import { get } from 'react-hook-form-v7';
var setCustomValidity = function setCustomValidity(ref, fieldPath, errors) {
  if (ref && 'reportValidity' in ref) {
    var error = get(errors, fieldPath);
    ref.setCustomValidity(error && error.message || '');
    ref.reportValidity();
  }
};

// Native validation (web only)
export var validateFieldsNatively = function validateFieldsNatively(errors, options) {
  var _loop = function _loop(fieldPath) {
    var field = options.fields[fieldPath];
    if (field && field.ref && 'reportValidity' in field.ref) {
      setCustomValidity(field.ref, fieldPath, errors);
    } else if (field.refs) {
      field.refs.forEach(function (ref) {
        return setCustomValidity(ref, fieldPath, errors);
      });
    }
  };
  for (var fieldPath in options.fields) {
    _loop(fieldPath);
  }
};